<template>
	<!-- 设置团长活动机制 -->
	<el-drawer title="设置团长活动机制" size="88%" class="edit-shop" :visible.sync="dialogEditShopVisible" @close="resetForms('EditShopFrom')">
		<el-form :model="EditShopFrom" ref="EditShopFrom" label-width="150px" class="mt-24" :rules="EditShopRules">
			<el-row>
				<el-col :span="14">
					<el-form-item label="设置团长活动机制" prop="product_activity_ratio">
						<el-radio v-model="radio" label="1">一键填写</el-radio>
						<el-radio v-model="radio" label="2">分别填写</el-radio>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="14" v-if="radio === '1'">
					<el-form-item label="活动佣金率" prop="product_activity_ratio">
						<span>{{ commission_rate || '-' }} %</span>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="radio === '1'">
				<el-col :span="14">
					<el-form-item prop="service_ratio">
						<span slot="label">
							<el-tooltip placement="top">
								<div slot="content">
									服务费率不得低于当前活动要求，
									<br />
									高于你的服务费率
								</div>
								<i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
							</el-tooltip>
							活动服务费率
						</span>
						<el-input
							oninput="value=value.replace(/[^0-9.]/g,'')"
							v-model="EditShopFrom['service_ratio']"
							autocomplete="off"
							placeholder="请输入数字"
						>
              <el-button slot="append">%</el-button>
            </el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="radio === '1'">
				<el-col :span="14">
					<el-form-item prop="promotion_end_time">
						<span slot="label">
							<el-tooltip placement="top">
								<div slot="content">
									提报后团长审核通过则推广开始，
									<br />
									超7天未审核自动拒绝申请。
									<br />
									设定推广结束时间需大于活动要求最短推广周期。
								</div>
								<i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
							</el-tooltip>
							推广结束时间
						</span>
						<el-date-picker v-model="value1" type="date" value-format="yyyy-MM-dd" @change="changeTimed" placeholder="选择日期"></el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="radio === '1'">
				<el-col :span="14">
					<el-form-item prop="phone_number">
						<span slot="label">联系电话</span>
						<el-input
							oninput="value=value.replace(/[^0-9.]/g,'')"
							v-model="EditShopFrom['phone_number']"
							autocomplete="off"
							placeholder="请输入联系电话"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<multi-table :columns="columns" :list="list" :showPager="false"></multi-table>
		<div class="footer mt-20 fz-14">
			<div>
				<el-checkbox v-model="checked">勾选代表同意</el-checkbox>
				<a href="https://automan.jinritemai.com/docpage/views/f853dd52-c2e8-4ed4-a4a6-9ef4700210fd" target="_blank" class="yx-color-primary ml-6">
					《招商活动服务协议》
				</a>
			</div>
			<div class="flex">
				<el-button @click="dialogEditShopVisible = false">取 消</el-button>
				<el-button type="primary" @click="signUp">报 名</el-button>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import { validateTel } from '@/utils/validate';
import { applyactivity, batchApplyActivityDouyin } from '@/api/secondColonelManage';
import { columnsWithText, columnsWithInput } from './settingColumn';
export default {
	name: 'editShopDialog',
	data() {
		return {
			dialogEditShopVisible: false,
			EditShopFrom: {
				service_ratio: '',
				promotion_end_time: '',
				phone_number: '',
			},
			EditShopRules: {
				service_ratio: [{ required: true, message: '服务费率不可为空', trigger: 'blur' }],
				promotion_end_time: [{ required: true, message: '推广结束时间不可为空', trigger: 'blur' }],
				phone_number: [{ required: true, validator: validateTel, trigger: 'blur', message: '联系电话不可为空'}],
			},
			row: {},
			activity_id: '',
			value1: '',
			radio: '1',
			checked: false,
			authorityId: '',
			commission_rate: '',
			list: [
				{
					activityServiceRateInput: '',
					promotionEndTimeInput: '',
					contactPhoneInput: '',
				},
			],
		};
	},
	computed: {
		columns() {
			return this.radio === '1' ? columnsWithText : columnsWithInput;
		},
		isBatch() {
			return this.list.length > 1;
		},
	},
	methods: {
		//编辑商品机制
		async show(list, activity_id, authority_id,commission_rate) {
			this.activity_id = activity_id;
			this.authorityId = authority_id;
			this.radio = '1';
			this.commission_rate = commission_rate;
			list.map(item => {
				return {
					...item,
					activityServiceRateInput: '',
					promotionEndTimeInput: '',
					contactPhoneInput: '',
				};
			});
			this.list = list;
			this.dialogEditShopVisible = true;
		},
		//报名
		async signUp() {
			if (!this.checked) {
				this.$message.warning('请先勾选《招商活动服务协议》');
				return;
			}
			const { activity_id, EditShopFrom, list, authorityId: authority_id } = this;
			console.log('list ==== ', this.list);
			if (this.radio === '2') {
				// 分别填写
				if (!this.validateBatchData()) {
					return;
				}
				let params = {
					authorityId: authority_id,
					activityId: activity_id,
					productList: this.list.map(item => ({
						activityProductId: item.id,
						serviceRatio: item.activityServiceRateInput,
						promotionEndTime: item.promotionEndTimeInput ? Date.parse(item.promotionEndTimeInput) / 1000 - 8 * 3600 : '',
						phoneNumber: item.contactPhoneInput,
					})),
				};
				console.log('params', params);

				const { code } = await batchApplyActivityDouyin(params);
				if (code === 0) {
					this.$message.success('报名任务提交成功，请从[二级团提报记录]查看是否报名成功');
					this.dialogEditShopVisible = false;
				}
				this.$emit('refresh');
			} else {
				// 一键填写
				if (!this.validateSingleData()) {
					return;
				}
				
				let params = {
					authorityId: authority_id,
					activityId: activity_id,
					productList: this.list.map(item => ({
						activityProductId: item.id,
						serviceRatio: this.EditShopFrom.service_ratio,
						promotionEndTime: this.EditShopFrom.promotion_end_time,
						phoneNumber: this.EditShopFrom.phone_number,
					})),
				};
				console.log('params', params);

				const res = await batchApplyActivityDouyin(params);
				console.log('res',res)
				if (res.code === 0) {
					this.$message.success('报名任务提交成功，请从[二级团提报记录]查看是否报名成功');
					this.dialogEditShopVisible = false;
				}
				this.$emit('refresh');
			}
		},
		changeTimed(value) {
			this.EditShopFrom.promotion_end_time = value ? Date.parse(value) / 1000 - 8 * 3600 : '';
		},
		// 分别填写模式下批量数据校验
		validateBatchData() {
			let isValid = true;
			let errorMsg = '';
			
			for (let i = 0; i < this.list.length; i++) {
				const item = this.list[i];
				
				//校活动服务费率
				if (!item.activityServiceRateInput) {
					errorMsg = `第${i + 1}行：请输入活动服务费率`;
					isValid = false;
					break;
				}
				
				// 校验推广结束时间
				if (!item.promotionEndTimeInput) {
					errorMsg = `第${i + 1}行：请选择推广结束时间`;
					isValid = false;
					break;
				}
				
				const selectedDate = Date.parse(item.promotionEndTimeInput) / 1000 - 8 * 3600;
				const today = new Date().setHours(0, 0, 0, 0)/1000;
				if (selectedDate < today) {
					errorMsg = `第${i + 1}行：推广结束时间不能早于今天`;
					isValid = false;
					break;
				}
				
				// 校验联系电话
				if (!item.contactPhoneInput) {
					errorMsg = `第${i + 1}行：请输入联系电话`;
					isValid = false;
					break;
				}
				
				if (item.contactPhoneInput.length !== 11) {
					errorMsg = `第${i + 1}行：手机号应为11位`;
					isValid = false;
					break;
				}
				
				if (!/^1[3-9]\d{9}$/.test(item.contactPhoneInput)) {
					errorMsg = `第${i + 1}行：请输入正确的手机号`;
					isValid = false;
					break;
				}
			}
			
			if (!isValid) {
				this.$message.error(errorMsg);
			}
			
			return isValid;
		},
		
		// 一键填写模式下单个数据校验
		validateSingleData() {
			let errorMsg = '';
			
			// 校验活动服务费率
			if (!this.EditShopFrom.service_ratio) {
				errorMsg = '请输入活动服务费率';
			}
			
			if (errorMsg) {
				this.$message.error(errorMsg);
				return false;
			}
			
			// 校验推广结束时间
			if (!this.EditShopFrom.promotion_end_time) {
				this.$message.error('请选择推广结束时间');
				return false;
			}
			
			const selectedDate = this.EditShopFrom.promotion_end_time
			const today = new Date().setHours(0, 0, 0, 0)/1000;
			
			if (selectedDate < today) {
				this.$message.error('推广结束时间不能早于今天');
				return false;
			}
			
			// 校验联系电话
			if (!this.EditShopFrom.phone_number) {
				this.$message.error('请输入联系电话');
				return false;
			}
			
			if (this.EditShopFrom.phone_number.length !== 11) {
				this.$message.error('手机号应为11位');
				return false;
			}
			
			if (!/^1[3-9]\d{9}$/.test(this.EditShopFrom.phone_number)) {
				this.$message.error('请输入正确的手机号');
				return false;
			}
			
			return true;
		},
		//重置弹框表单
		resetForms(from) {
			this.value1 = '';
			this.$refs[from].resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
//.edit-shop {
	///deep/ .suffix-icon::after {
	//	content: '%';
	//	width: 33px;
	//	background-color: #f7f8fa;
	//	border-bottom-right-radius: 2px;
	//	border-top-right-radius: 2px;
	//}
	///deep/ .suffix-icon-1::after {
	//	content: '￥';
	//	width: 33px;
	//	background-color: #f7f8fa;
	//	border-bottom-right-radius: 2px;
	//	border-top-right-radius: 2px;
	//}
	///deep/ .el-input__suffix {
  //     height: 93%;
  //     right: 1px;
  //     top: -2px;
  //   }
//}

// 新增组件样式
::v-deep .error-msg {
	color: #f56c6c;
	font-size: 12px;
	margin-top: 4px;
}
::v-deep .el-drawer__header {
	padding: 16px 24px !important;
	margin: 0;
	border-bottom: 1px solid #f5f5f5;
	span {
		color: #333;
		font-weight: bold;
	}
}
::v-deep .el-drawer__body {
	padding: 0px 24px !important;
}
::v-deep .el-date-editor {
	width: 100%;
}
.footer {
	width: 100%;
	position: absolute;
	bottom: 0;
	right: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px;
	border-top: 1px solid #eeeeee;
	background: #ffffff;
	z-index: 99;
}
</style>
